<template>
  <div class="brandIdBlock">
    <el-button type="primary" v-if="!batchBrand" @click="useBrandConf" style="margin-bottom: 10px">一键应用品牌配置</el-button>
    <!-- <el-input v-if="!batchBrand" width="200px" style="margin-left: 10px;" type="text" clearable placeholder="输入品牌,回车后匹配填充" v-model="inputBrandText" @keyup.enter.native="batchFillBrand"> </el-input> -->
    <div class="brandId-row" v-for="shop in shopList" :key="shop.id">
      <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
      <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
        <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
      </el-tooltip>
      <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
      <el-select
        :value="valueMap[shop.id]"
        value-key="brandId"
        name-key="brandName"
        :loading="loading[shop.id]"
        clearable
        filterable
        remote
        :remote-method="($event) => remoteMethod($event, shop.id)"
        @visible-change="isShow => visibleSelect(isShow, shop.id)"
        @change="v => selectChange(v, shop.id)"
      >
        <el-option v-for="brandOp in brandOptions[shop.id]" :key="brandOp.brandId" :label="brandOp.brandName" :value="brandOp"> </el-option>
      </el-select>
      <el-link v-if="valueMap[shop.id] && valueMap[shop.id].brandId && !batchBrand" style="margin-left: 8px" @click="handleSetToShop(shop, valueMap[shop.id].brandName)">应用到其他店铺</el-link>
      <span v-if="getFail[shop.id]" style="color: red;margin-left: 10px; font-size: 12px;">店铺授权已失效</span>
    </div>
    <el-dialog-select-shop
        :visible.sync="shopDialogVisible"
        :shopData="shopList"
        :selected="selectShopIds"
        placeholder="店铺名称"
        @confirm="confirmSelectShop"
    ></el-dialog-select-shop>
  </div>
</template>

<script>
import { queryBrandList } from '@/servers/prod/center/xhs.js';
import { ApplyToOtherShop } from '@/servers/prod/center/kuaishou.js';
import { getApplyBrandConfig } from '@/servers/prod/center/pdd.js';
import { batchBrandFill } from '@/api/prod/center/index.js';

import _ from 'lodash';

const PLATFORMID = 'xhs';

export default {
  name: 'BrandIdBlock',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    shopList: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    categoryIds: {
      type: Array,
      default() {
        return [];
      },
    },
    batchBrand: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      valueMap: {},
      brandOptions: {},
      loading: {},
      getFail: {},
      inputBrandText: '',
      shopDialogVisible: false,
      selectShopIds: '',
      applyShopName: '',
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.valueMap = {};
        if (v && v.length) {
          v.forEach(item => {
            const { shopId, brandId, brandName } = item || {};
            if (shopId && brandId) {
              this.$set(this.valueMap, shopId, item);

              !brandName && this.getBrandList(shopId);
            }
          });
        }
      },
    },
    categoryIds: {
      immediate: true,
      handler(v) {
        this.brandOptions = {};
      },
    },
  },
  methods: {
    visibleSelect(isShow, shopId) {
      if (!isShow) return;
      if (!this.brandOptions[shopId]?.length) {
        this.getBrandList(shopId);
      }
    },
    selectChange(v, shopId) {
      this.valueMap[shopId] = v;
      this.valueChange();
    },
    valueChange() {
      const brandList = Object.values(this.valueMap).filter(Boolean).map(item => {
        return {
          ...item,
          channel: this.shopList.find(shop => shop.id == item.shopId)?.channel
        }
      });
      this.$emit('change', brandList);
    },
    remoteMethod(query, shopId) {
      this.getBrandList(shopId, query);
    },
    // 获取品牌
    async getBrandList(shopId, query) {
      try {
        let categoryIds = this.categoryIds || [];
        if (categoryIds.length) {
          let params = {
            shopId,
            categoryLeafId: categoryIds[categoryIds.length - 1],
            pageNumber: 1,
            pageSize: 50,
            keyword: query || '',
          };
          this.$set(this.loading, shopId, true);
          const res = await queryBrandList(params, { isNeedFailNotice: true });
          this.loading[shopId] = false;
          this.$set(this.getFail, shopId, !res);
          let brands = res.data?.brands || [];
          const list = brands.map(item => {
            return {
              shopId,
              brandId: item.id * 1,
              brandName: item.name,
            };
          });
          if (this.valueMap[shopId]) {
            const findItem = list.find(item => item.brandId === this.valueMap[shopId].brandId);
            if (!findItem) {
              this.valueMap[shopId] = null;
              this.valueChange();
            } else if (!this.valueMap[shopId].brandName) {
              this.valueMap[shopId].brandName = findItem.brandName;
              this.valueChange();
            }
          }

          this.$set(this.brandOptions, shopId, list);
        }
      } catch (error) {
        console.log(error, '-----error');
      }
    },
    // 一键应用品牌配置（内部方法，支持是否跳过已有值）
    async applyBrandConfInternal({ skipExisting }) {
      const categoryId = this.categoryIds?.length ? this.categoryIds[this.categoryIds.length - 1] : null;
      if (!categoryId) return;
      const categoryBrandRelations = await getApplyBrandConfig({ categoryId, shopType: PLATFORMID });
      const additionsMap = {};

      const existingFilledShopIds = skipExisting
        ? Object.keys(this.valueMap).filter(id => this.valueMap[id] && this.valueMap[id].brandId)
        : [];

      this.shopList.forEach(shop => {
        const shopId = shop.id;
        const relations = (categoryBrandRelations.find(item => shopId == item.shopId) || {}).relations || [];
        const valueItem = relations.find(item => item.categoryId == categoryId);
        if (valueItem && (!skipExisting || !existingFilledShopIds.includes(String(shopId)))) {
          additionsMap[shopId] = {
            shopId,
            brandId: valueItem.vid,
            brandName: valueItem.vvalue,
            categoryId,
          };
        }
      });

      const unmatchedShopIds = this.shopList
        .map(shop => shop.id)
        .filter(shopId => {
          const hasRelation = categoryBrandRelations.some(
            item => item.shopId == shopId && item.relations.find(r => r.categoryId == categoryId)
          );
          const skip = skipExisting && existingFilledShopIds.includes(String(shopId));
          return !hasRelation && !skip;
        });

      if (unmatchedShopIds.length > 0) {
        const res = await this.getApplyToOtherShop({
          shopType: PLATFORMID,
          shopIds: unmatchedShopIds.join(','),
          categoryId,
        });
        res && Object.keys(res).forEach(shopIdStr => {
          if (skipExisting && existingFilledShopIds.includes(String(shopIdStr))) return;
          const shopData = res[shopIdStr];
          if (shopData && shopData.vid) {
            additionsMap[Number(shopIdStr)] = {
              shopId: Number(shopIdStr),
              brandId: shopData.vid,
              brandName: shopData.vvalue,
              categoryId,
            };
          }
        });
      }

      Object.keys(additionsMap).forEach(shopId => {
        this.$set(this.valueMap, shopId, additionsMap[shopId]);
      });
      this.valueChange();
    },
    // 初始化时调用：不跳过已有值，全部重新应用
    async useBrandConfInit() {
      await this.applyBrandConfInternal({ skipExisting: false });
    },
    // 用户手动点击"一键应用品牌配置"：跳过已有值的店铺
    async useBrandConf() {
      await this.applyBrandConfInternal({ skipExisting: true });
    },
    // 批量填充品牌
    async batchFillBrand() {
      const categoryId = this.categoryIds?.length ? this.categoryIds[this.categoryIds.length - 1] : null;
      if (!categoryId || !this.inputBrandText) return;
      const shopIds = this.shopList.map(shop => shop.id);
      const res = await batchBrandFill({ brandName: this.inputBrandText, categoryId, shopIds, shopType: PLATFORMID }, '/xhs/batchBrandFill');
      if (res && res.data) {
        (res.data || []).forEach(item => {
          const { shopId, scmBrand } = item;
          if (scmBrand) {
            this.$set(this.valueMap, shopId, {
              shopId,
              brandId: scmBrand.brandId,
              brandName: scmBrand.brandName,
            });
          }
        });
        this.valueChange();
      }
    },
    // 应用到其他店铺
    handleSetToShop(shop, applyBrandName) {
      this.shopDialogVisible = true;
      this.applyShopName = applyBrandName;
    },
    confirmSelectShop(shops) {
      this.shopDialogVisible = false;
      this.$confirm(
        `选中店铺将匹配品牌【${this.applyShopName}】，匹配后将覆盖原品牌值，未匹配到将跳过，是否确认`,
        '提示',
        {
          confirmButtonText: '确定',
          type: 'warning',
        }
      )
        .then(async () => {
          const shopIds = shops.map(item => item.id);
          const categoryId = this.categoryIds?.length ? this.categoryIds[this.categoryIds.length - 1] : null;
          const params = {
            shopType: PLATFORMID,
            shopIds: shopIds.join(','),
            categoryId,
            brandName: this.applyShopName || '',
          };
          const res = await this.getApplyToOtherShop(params);
          for (const key in res) {
            const shopInfo = res[key];
            if (shopInfo && shopInfo.vid) {
              this.$set(this.valueMap, Number(key), {
                shopId: Number(key),
                brandId: shopInfo.vid,
                brandName: shopInfo.vvalue,
              });
            }
          }
          this.valueChange();
          this.$message.success('更新品牌成功！');
        })
        .catch(() => {});
    },
    async getApplyToOtherShop(payload) {
      const res = await ApplyToOtherShop({ ...payload });
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.brandId-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .shop-title {
    margin-right: 8px;
  }
}
</style>
